export const groupPositions = (positions, positionGroups) => {
  if (!Array.isArray(positionGroups) || positionGroups.length === 0) {
    return null;
  }

  const groupsById = new Map();

  positionGroups.forEach((group) => {
    if (!groupsById.has(group.id)) {
      groupsById.set(group.id, {
        group,
        positions: [],
      });
    }
  });

  const ungroupedPositions = [];

  positions.forEach((position) => {
    const matchingGroup = groupsById.get(position.groupId);

    if (matchingGroup) {
      matchingGroup.positions.push(position);
    } else {
      ungroupedPositions.push(position);
    }
  });

  return {
    groups: Array.from(groupsById.values()).filter(
      ({ positions: groupedPositions }) => groupedPositions.length > 0
    ),
    ungroupedPositions,
  };
};
